import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './i18n/config';
import { injectMotionKeyframes } from './design-system/motion';
import { initSentry } from './utils/sentry';
import { ToastContainer } from './design-system/components/Toast';
import { ReauthModal } from './components/ReauthModal';
import { PwaUpdatePrompt } from './components/PwaUpdatePrompt';
import { App } from './App';

initSentry();
injectMotionKeyframes();

// ToastContainer fournit le contexte useToast à toute l'app — sans lui, le
// contexte par défaut est un no-op silencieux et AUCUN toast ne s'affiche
// (découvert via ED-01 : le message « nom obligatoire » ne rendait pas).
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ToastContainer>
      <App />
      {/* BK-06 : reconnexion in-place sur 401 avec brouillon actif. */}
      <ReauthModal />
      {/* Propose le rechargement quand un nouveau service worker attend. */}
      <PwaUpdatePrompt />
    </ToastContainer>
  </StrictMode>,
);
